<template>
  <div>
    <v-tabs
        v-model="currentTab"
        :show-arrows="$vuetify.breakpoint.mobile"
    >
      <v-tabs-slider color="pink"></v-tabs-slider>

      <v-tab
          icons-and-text
          v-for="tab in tabs"
          :key="tab.id"
      >
        <v-icon left>{{tab.icon}}</v-icon>
        {{ tab.title }}
      </v-tab>
    </v-tabs>
    <v-card
        :class="{'rounded-0': $vuetify.breakpoint.mobile, 'sm': !$vuetify.breakpoint.mobile}"
        :elevation="$vuetify.breakpoint.mobile ? 1 : 2"
    >
      <v-card-text>
        <BuyoutList v-if="currentTab === tabs.purchases.id"></BuyoutList>
        <CommentList v-if="currentTab === tabs.comments.id"></CommentList>
        <BuyoutList
            v-if="currentTab === tabs.archive.id"
            :archived="true"
        ></BuyoutList>
        <About v-if="tabs.about && currentTab === tabs.about.id"></About>
      </v-card-text>
    </v-card>

    <DemoWarning v-if="isDemo"></DemoWarning>
  </div>
</template>

<script>
import BuyoutList from '@/components/BuyoutList'
import CommentList from '@/components/CommentList'
import DemoWarning from '@/components/DemoWarning'
import About from '@/components/About'
import {getSourceIsDemo} from '@/composables/context'
import {getAcquiring} from '@/composables/acquiring'

const tabs = {
  purchases: {
    id: 0,
    title: 'Покупки',
    icon: 'mdi-cart-check'
  },
  comments: {
    id: 1,
    title: 'Комментарии',
    icon: 'mdi-comment-multiple'
  },
  archive: {
    id: 2,
    title: 'Архив',
    icon: 'mdi-eye-off'
  },
};

export default {
  name: 'SourceContent',
  components: {CommentList, BuyoutList, DemoWarning, About},
  data () {
    return {
      currentTab: null,
      isDemo: getSourceIsDemo(),
      tabs
    }
  },
  computed: {
    acquiring: getAcquiring,
  },
  mounted() {
    if(this.acquiring.data && this.acquiring.data.displayLegalInfo) {
      this.tabs.about = {
        id: 3,
        title: 'О нас',
        icon: 'mdi-information-outline'
      }
    }
  }
}
</script>

<style scoped>

</style>